<template>
  <div class="NavInvoice_vue font-jumperlight">
    <b-container fluid class="mt-3 px-0">
      <b-row>
        <b-col cols=6>
          <div class="d-flex justify-content-between">
            <div class="d-flex justify-content-between w-100">
              <div class="position-absolute pt-2 pl-3 search-icon">
                <i class="fas fa-search"></i>
              </div>
              <b-form-input
                  debounce="600"
                  v-model="searchTerm"
                  class="w-100 search-bar position-relative"
                  placeholder="Írd be a számlaszámot"
                  style="padding-left: 45px !important;"
              ></b-form-input>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>


    <div v-if="invoices" class="">
      <div
          class="list-item my-2 d-flex p-3 mb-3"
          v-for="(item, index) in invoices.content"
          :key="'listViewItem_' + index"
      >
        <b-container fluid class="">
          <div>
            <div class="list-label flex-fill">
              <b-row class="invoice-label" align-h="between" align-v="center">
                <b-col class="col-12 col-md-4">
                  <div
                      v-if="invoiceDirection === 'OUTBOUND'"
                      class="name-label ellipsis-overflow mr-4"
                  >
                    {{ item.customerName }}
                  </div>
                  <div
                      v-if="invoiceDirection === 'INBOUND'"
                      class="name-label ellipsis-overflow"
                  >
                    {{ item.supplierName }}
                  </div>
                  <div v-if="item.invoiceNumber" class="small">
                    {{ item.invoiceNumber }}
                  </div>
                </b-col>
                <b-col>
                  <div v-if="item.invoiceIssueDate" class="mt-2 mt-md-0">
                  <span class="rounded-pill border bg-white small p-2">
                  {{
                      $moment(new Date(item.invoiceIssueDate)).format(
                          "YYYY-MM-DD"
                      )
                    }}
                  </span>
                  </div>
                </b-col>
                <b-col class="text-right mt-2 mt-md-0">
                  <div
                      v-if="item.invoiceGrossAmountHuf"
                      class="ml-auto price-label text-nowrap"
                  >
<!--                    {{-->
<!--                      (invoiceType === 'costs' ? '- ' : '') + Number(item.invoiceGrossAmountHuf).toLocaleString("hu-HU")-->
<!--                    }}-->
                    {{ Number(item.invoiceGrossAmountHuf).toLocaleString("hu-HU") }}
                    HUF
                  </div>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-container>
      </div>
    </div>

    <Paging
        v-if="invoices && invoices.content.length > 0"
        :item-per-page="itemPerPage"
        :total-rows="rowCount"
        @paging-change="updateTable"
    />
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import Paging from "./Paging";
import Api from "api-client";

export default {
  name: "NavInvoice",
  components: {
    Paging,
  },
  props: {
    invoiceDirection: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      invoices: null,
      searchTerm: "",
      page: 1,
      offset: 10,
      rowCount: 1,
      loading: false,
      itemPerPage: 10,
      navData: null,
      navNotFound: false
    };
  },
  methods: {
    updateTable(data) {
      this.page = data.pagingPage;
      this.offset = data.pagingOffset;
      this.loadInvoices();
    },

    loadInvoices() {
      if (!this.getActiveCompany) {
        alert('this.getActiveCompany is falsy')
        return;
      }

      this.loading = true;

      if (this.getActiveCompany?.id) {

        Api.getNavInvoices(this.getActiveCompany.id, this.invoiceDirection, {
          page: (this.page - 1), // This POS pwa start paging from 1 for some reason...
          size: this.offset,
          searchTerm: this.searchTerm,
        })
            .then((resp) => {
              this.loading = false;
              this.invoices = resp.data;
              this.rowCount = resp.data.totalNumberOfElements;
            })
            .catch((err) => {
              console.error(err);
              this.$toast.error({
                title: 'Sikertelen lekérdezés',
                message: 'Az adatok betöltése sikertelen',
              });
            })
      }
    },
  },
  created() {
    this.loadInvoices();
  },
  computed: {
    ...mapGetters("app", ["getActiveCompany"]),
  },
  watch: {
    searchTerm() {
      this.loadInvoices();
    },
  },
};
</script>

<style scoped>
.name-label {
  font-size: 1.2rem;
}

.additional-data {
  color: #252734;
}

.price-label {
  font-size: 1.3rem;
  margin-top: 0.4rem;
}

@media screen and (max-width: 768px) {
  .price-label {
    font-size: 1.2rem;
    margin-top: 0.2rem;
  }
}

.ellipsis-overflow {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.search-icon {
  color: gray;
  font-size: 1.3rem;
}

.search-bar {
  color: #000000 !important;
  background-color: #ffffff !important;
  border: 1px solid rgb(222, 226, 230) !important;
}

.list-item {
  background-color: #AEBFC7;
  border: none !important;
  box-shadow: 0px 20px 30px 0px rgba(0, 0, 0, 0.10) !important;
}
</style>
